// extracted by mini-css-extract-plugin
export default {"specialPostersContainer":"SpecialPosters_specialPostersContainer__IiUXT","header":"SpecialPosters_header__V-Z-g"};